"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _getObjectValue = _interopRequireDefault(require("get-object-value"));
//@ts-check

var position = {
  tl: "top left",
  tc: "top center",
  tr: "top right",
  rt: "right center",
  rc: "right center",
  rb: "right center",
  bl: "bottom left",
  bc: "bottom center",
  br: "bottom right",
  lt: "left center",
  lc: "left center",
  lb: "left center",
  cc: "center"
};

/**
 * @param {string} [loc]
 * @returns {string}
 */
var getPositionString = function getPositionString(loc) {
  return (0, _getObjectValue["default"])(position, [( /**@type string*/loc)]);
};
var _default = exports["default"] = getPositionString;
module.exports = exports.default;